import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	confluenceAfterUpgradeCalendarStandardModalTitle: {
		id: '@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.calendar-standard-modal.title',
		defaultMessage: 'Welcome to Standard',
		description: 'Title welcoming user to their Standard Trial',
	},
	confluenceAfterUpgradeCalendarStandardModalSubtitle: {
		id: '@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.calendar-standard-modal.subtitle',
		defaultMessage:
			'You successfully unlocked team calendars that bring schedules and work together.',
		description: 'Subtitle explaining to user the value of team calendars in their Standard Trial',
	},
	confluenceAfterUpgradeCalendarStandardModalPrimaryCTA: {
		id: '@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.calendar-standard-modal.primary-cta',
		defaultMessage: 'Get started',
		description:
			'CTA text prompting user to start playing around with team calendars on their Standard Trial',
	},
	confluenceAfterUpgradeCalendarStandardModalSecondaryCTA: {
		id: '@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.calendar-standard-modal.secondary-cta',
		defaultMessage: 'Close',
		description: 'CTA text prompting user to close the modal',
	},
	confluenceAfterUpgradeCalendarStandardModalEventTypes: {
		id: '@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.calendar-standard-modal.event-types',
		defaultMessage: 'Choose what event types you want to share',
		description: 'Text appearing in a list detailing Team Calendar features about event types',
	},
	confluenceAfterUpgradeCalendarStandardModalJiraWorkItems: {
		id: '@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.calendar-standard-modal.jira-work-items',
		defaultMessage: 'Add Jira work items, sprints and releases',
		description: 'Text appearing in a list detailing Team Calendar features about Jira work items',
	},
	confluenceAfterUpgradeCalendarStandardModalLinkEventsToSpaces: {
		id: '@atlassian/upgrade-free-pool-target-experiment.confluence.after-upgrade.calendar-standard-modal.link-events-to-spaces',
		defaultMessage: 'Link events to spaces and pages',
		description: 'Text appearing in a list detailing Team Calendar features about linking events',
	},
});
